import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { emailPattern, splitPattern } from '../../shared/constants';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { FileUploaderComponent } from '../../shared/file-uploader/file-uploader.component';
import { EmailFormatterService } from '../../email-formatter.service';

@Component({
	selector: 'app-send-mail',
	templateUrl: './send-mail.component.html',
	styleUrl: './send-mail.component.scss'
})
export class SendMailComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/company",
			name: "Companies"
		}
	];
	@ViewChild('fileUploaderComponent') fileUploaderComponent!: FileUploaderComponent;
	compId: any = null;
	defaultSubject = "3Cube Medicare - Duty of Care Services";
	defaultBody = '<p></p><p></p><p>We request you to please confirm the receipt of this email.</p><p>Best Regards,</p><p>DOC Team</p><p>3Cube Medicare</p><p>PHONE - +91 80-6912-3333</p><p>Email Id - rma@dutyofcare365.com</p>';
	/* defaultBody = '<div></div><div></div><div>We request you to please confirm the receipt of this email.</div><div>Best Regards,</div><div>DOC Team</div><div>3Cube Medicare</div><div>PHONE - +91 80-6912-3333</div><div>Email Id - rma@dutyofcare365.com</div>'; */
	requiredValidator = Validators.required;
	moduleForm: FormGroup = this.formBuilder.group({
		cc_emails: [null],
		bcc_emails: [null, [this.requiredValidator]],
		subject: [this.defaultSubject, [this.requiredValidator]],
		mail_content: [this.defaultBody, [this.requiredValidator]]
	});
	companyDetails: any = null;
	showMailLoader = false;
	pageLoading1 = false;
	pageLoading2 = false;
	accessLoader = false;
	user_type: any = "";
	files: File[] = [];
	vessels: any[] = [];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
				/* [{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }] */
			]
		}
	};
	mailIdPlaceholder = "Please add email address and press space bar.";
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		if (!control.value.match(emailPattern)) {
			return {
				'emailerr': true
			};
		}
		return null;
	}
	splitPattern = splitPattern;

	constructor(private emailFormatter: EmailFormatterService, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe({
			next: (data: any) => {
				this.accessLoader = false;
				try {
					this.user_type = data.res[0].user_type;
				} catch (error) { }
			}, error: (error: any) => {
				this.accessLoader = false;
			}
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.compId = routeParams["compId"];
			this.breadcrumbList.push({ path: "/app/send-mail/" + this.compId, name: "Send Mail" });
			this.getDetails();
			this.getVessels();
		});
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getCompanyDetails({ "id": this.compId }).subscribe({
			next: (data: any) => {
				this.companyDetails = data.data;
				this.f1.cc_emails.setValue(this.companyDetails.com_ccemail);
				this.pageLoading1 = false;
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getVessels() {
		this.pageLoading2 = true;
		this.apiService.vessel_by_company({ "id": this.compId }).subscribe({
			next: (data: any) => {
				let emails = data.map((v) => {
					v.name = `${v.name}:${v.email}`;
					return v;
				});
				this.vessels = emails;
				this.f1.bcc_emails.setValue(emails);
				this.pageLoading2 = false;
			}, error: (error) => {
				this.vessels = [];
				this.pageLoading2 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	public uploadFile(files: NgxFileDropEntry[]) {
		for (let i = 0; i < files.length; i++) {
			if (files[i].fileEntry.isFile) {
				const fileEntry = files[i].fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.files.push(file);
				});
				this.moduleForm.markAsDirty();
			} else {
				this.toastr.error("Invalid File Format.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}
	}

	removeFile(index: number) {
		this.files.splice(index, 1);
	}

	getBCC_Count() {
		let count = 0;
		try {
			count = this.f1.bcc_emails.value ? this.f1.bcc_emails.value.map((email) => email.email).length : 0;
		} catch (error) { }
		return count;
	}

	get f1() { return this.moduleForm.controls; }

	showError(field: string) {
		if (this.f1[field].invalid && (this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	convertPToDiv(html: string): string {
		return html
			.replace(/<p(\s[^>]*)?>/gi, '<div$1>')
			.replace(/<\/p>/gi, '</div>');
	}

	sendMail() {
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required parameters", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let cc_emails = this.f1.cc_emails.value ? this.f1.cc_emails.value.map((email) => email.value) : [];
		let bcc_emails = this.f1.bcc_emails.value ? this.f1.bcc_emails.value.map((email) => email.email) : [];
		let attachments = this.fileUploaderComponent.getAttachments();
		let formData = new FormData();
		const emailReadyHtml = this.emailFormatter.prepareQuillHtmlForEmail(this.f1.mail_content.value);
		formData.append("id", this.compId);
		formData.append("cc_emails", JSON.stringify(cc_emails));
		formData.append("bcc_emails", JSON.stringify(bcc_emails));
		formData.append("subject", this.f1.subject.value);
		formData.append("mail_content", emailReadyHtml);
		formData.append("attachments", JSON.stringify(attachments));
		/* formData.append("count", this.files.length.toString());
		for (let i = 0; i < this.files.length; i++) {
			formData.append("attachments_" + i, this.files[i]);
		} */

		/* formData.append("language",this.f1.language.value); */
		this.showMailLoader = true;
		this.apiService.sendMail(formData).subscribe({
			next: data => {
				this.showMailLoader = false;
				this.toastr.success("Mail sent successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.router.navigate(['/app/company']);
			}, error: (error) => {
				this.showMailLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}
}
